var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrevienceLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#0CA7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 28V26H22V28H10ZM15.65 23.15L10 17.5L12.1 15.35L17.8 21L15.65 23.15ZM22 16.8L16.35 11.1L18.5 9L24.15 14.65L22 16.8ZM26.6 27L13.55 13.95L14.95 12.55L28 25.6L26.6 27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrevienceLetter);
export default __webpack_public_path__ + "static/media/grevience-letter.e4bad90e6faf9186298ca6d097d60042.svg";
export { ForwardRef as ReactComponent };